import { Component, inject } from '@angular/core';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute } from '@angular/router';
import { MenuActions } from '../../shared/states/menu_actions';
import blogDetails from '../../../assets/blog-details.json';

@Component({
  selector: 'ln-blog-details',
  imports: [LnArrowBackSvgIconComponent, LnPagesArmorComponent, TranslocoPipe],
  templateUrl: './blog-details.component.html',
  styleUrl: './blog-details.component.css',
})
export class BlogDetailsComponent {
  private routes = inject(ActivatedRoute);
  protected article = blogDetails;
  menuAction = inject(MenuActions);

  // ngOnInit(): void {
  //   // this.getQueryParams();
  // }

  // getQueryParams(): void {
  //   this.routes.queryParams.subscribe(params => {
  //     const id: string = params['id'];
  //     if (id) {
  //     }
  //   });
  // }

  navigateToContactPage(): void {
    this.menuAction.navigateToContactPage();
  }

  navigateBack(): void {
    this.menuAction.navigateBack();
  }
}
